import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


import { HelperNavigationModule } from '@core/components/helpers/navigation/navigation.module';
import { HelperIconsModule } from '@core/components/helpers/icons/icons.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';

import { StoragePagePreviewComponent } from './page-preview/page-preview.component';
import { StorageGridPreviewComponent } from './storage-grid-preview/grid-preview.component';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        HelperNavigationModule,
        HelperIconsModule,
        HelperBoxModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        StoragePagePreviewComponent,
        StorageGridPreviewComponent,
    ],
    exports: [
        StoragePagePreviewComponent,
        StorageGridPreviewComponent,
    ],
})
export class StoragePreviewModule { }
